<template>
  <div id="expensesComponent">
    <page-title :heading="heading" :subheading="subheading" :icon="icon"></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
        <v-layout class="mb-3" v-if="showMessage()">
          <v-card>
            <v-card-text class="d-flex flex-row">
              <v-icon size="36" class="mx-0 px-0" style="color: tomato">
                mdi-alert-circle-outline
              </v-icon>
              <h3 class="subtitle-2 mt-2 ml-1" style="color: tomato">
                {{
                  $t('expenses.pendingExpenses', { totalPending: totalPending })
                }}
              </h3>
              <router-link class="mt-2 ml-1" :to="{ path: '/missingExpenses' }">
                Ver lista de pendientes
              </router-link>
            </v-card-text>
            <h6 class="pl-5" style="color: orange">
              {{ $t('expenses.filterMessage') }}
            </h6>
          </v-card>
        </v-layout>
        <v-alert v-if="userLogged && pettyCashAmount > 0" class="m-2" icon="monetization_on" :value="true" color="primary" outline >
          <h3 class="mb-0">
            <span class="font-weight-black">{{ $t('pettyCash.pettyCash') }}:</span>
            {{ pettyCashAmount | formatCurrency }} ({{ tagMoneda }})
          </h3>
        </v-alert>
        <v-alert v-if="userLogged && amexCardAmount > 0" class="m-2" icon="" :value="true" color="primary" outline >
          <h3 class="mb-0">
            <span class="font-weight-black">{{ $t('pettyCash.amexCardMessage') }}</span>
          </h3>
        </v-alert>
        <v-spacer></v-spacer>
        <v-btn color="primary" round outline to="/rejected_expenses">
          <v-icon left>far fa-times-circle fa-fw icon-color</v-icon>
          {{ $t('expenseRejected.goRejectedExpenses') }}
        </v-btn>
        <v-dialog v-model="dialog" max-width="600px" persistent>
          <template v-slot:activator="{ on }">
            <v-btn :disabled="lockButton()" v-on="on" color="primary" round outline>
              <v-icon left>attach_money</v-icon>
              {{ $t('expenses.add') }}
            </v-btn>
          </template>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">
                {{ formTitle }}
              </h2>
            </v-toolbar>
            <v-card-text>
              <v-form lazy-validation ref="form" v-model="valid">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                      <v-menu
                        v-model="start"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :disabled="editable"
                            clearable
                            required
                            :rules="rules.required"
                            :error-messages="errors.start_date"
                            v-model="editedItem.start_date"
                            :label="$t('general.startDate')"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          >
                          </v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          :locale="$t('general.locale')"
                          v-model="editedItem.start_date"
                          :max="maxDate"
                          @input="start = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-menu
                        v-model="end"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :disabled="editable"
                            clearable
                            required
                            :rules="rules.required"
                            v-model="editedItem.end_date"
                            :error-messages="errors.end_date"
                            :label="$t('general.endDate')"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          >
                          </v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          :locale="$t('general.locale')"
                          v-model="editedItem.end_date"
                          :min="minDate"
                          @input="end = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs8 sm8 md8>
                      <v-autocomplete
                        :disabled="editable"
                        v-model="editedItem.project_id"
                        required
                        :rules="rules.required"
                        :error-messages="errors.project_id"
                        :label="$t('general.project')"
                        :items="projects"
                        item-value="id"
                        item-text="name"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                      <v-checkbox v-if="hasMultiProjects" v-model="selectMultiProject" :disabled="editable" :error-messages="errors.has_request" :label="$t('general.multiProjects')"></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-autocomplete v-if="hasMultiProjects && selectMultiProject" v-model="editedItem.project_list" :items="projectsSecond" :label="$t('general.projectSecond')" item-value="id" item-text="name" :error-messages="errors.project_list" :disabled="editable" required multiple></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        :disabled="editable"
                        clearable
                        required
                        :rules="rules.required"
                        :error-messages="errors.description"
                        :label="$t('general.description')"
                        v-model="editedItem.description"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                      <v-radio-group v-model="type" row>
                        <v-flex v-if="amexCardAmount > 0" md12>
                          <v-radio :disabled="isDisabledAmexCard" :label="$t('amexCard.title')" value="amexCard"></v-radio>
                        </v-flex>
                        <v-flex v-if="pettyCashAmount > 0" md12>
                          <v-radio :disabled="isDisabledPettyCash" :label="$t('pettyCash.title')" value="pettyCash"></v-radio>
                        </v-flex>
                        <v-flex md12>
                          <v-radio :disabled="isDisabledAdvance" :label="$t('general.advance')" value="advance"></v-radio>
                        </v-flex>
                        <v-flex md12>
                          <v-radio :disabled="isDisabledRefund" :label="$t('general.refund')" value="refund"></v-radio>
                        </v-flex>
                        <v-flex md12>
                          <v-radio :disabled="isDisabledOkBlue" :label="$t('general.okBlue')" value="okBlue"></v-radio>
                        </v-flex>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs8 sm8 md8>
                      <div class="d-flex align-center">
                        <v-checkbox v-if="type === 'pettyCash' || type === 'amexCard'" v-model="editedItem.isVoucherAmount" @change="viewVoucherAmountCheck" :disabled="isDisabledOkBlue" :label="$t('general.okBlue')"></v-checkbox>
                        <v-text-field v-if="type === 'advance'" v-model.number="editedItem.advance" :disabled="editable || isPettyCash" :rules="rules.digit" :persistent-hint="true" :label="$t('general.advance') + $t('general.optionalField')" prepend-icon="attach_money" type="number" required clearable></v-text-field>
                        <v-text-field v-if="type === 'okBlue' || viewVoucherAmount" v-model.number="editedItem.voucher_amount" :disabled="editable || isPettyCash" :label="$t('general.voucherAmount')" :rules="rules.digit" required type="number" prepend-icon="attach_money"></v-text-field>
                      </div>
                      <v-alert v-if="type === 'pettyCash' && pettyCashAmount" icon="monetization_on" :value="true" color="primary" outline >
                        <h3 class="mb-0">
                          <span class="font-weight-black">{{$t('pettyCash.balanceIn')}} {{ $t('pettyCash.pettyCash') }}:</span>
                          {{ pettyCashAmount | formatCurrency }} ({{ tagMoneda }})
                        </h3>
                      </v-alert>
                      <v-alert v-if="type === 'amexCard' && amexCardAmount" icon="monetization_on" :value="true" color="primary" outline >
                        <h3 class="mb-0">
                          <span class="font-weight-black">{{$t('pettyCash.balanceIn')}} {{ $t('pettyCash.amexCard') }}:</span>
                          {{ amexCardAmount | formatCurrency }} ({{ tagMoneda }})
                        </h3>
                      </v-alert>
                    </v-flex>
                    <v-flex xs12 sm12 md 12>
                      <v-checkbox
                        v-if="ifViatics"
                        :disabled="editable"
                        v-model="editedItem.has_request"
                        :error-messages="errors.has_request"
                        :label="$t('expenses.relateToRequest')"
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex v-if="viatics.length > 0 && editedItem.has_request" xs12 sm12 md12>
                      <v-autocomplete v-model="editedItem.viatic_request_id" :items="viatics" :disabled="editable" :error-messages="errors.viatic_request_id" :label="$t('viatics.title')" item-value="id" item-text="folio">
                        <template slot="item" slot-scope="data">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-list-tile-content v-on="on">
                                <v-list-tile-title
                                  v-html="data.item.folio"
                                ></v-list-tile-title>
                              </v-list-tile-content>
                            </template>
                            <span>
                              <pre style="color: #ffffff"
                                >{{ $t('general.description') }}: {{
                                  data.item.description
                                }}</pre
                              >
                              <pre style="color: #ffffff"
                                >{{ $t('general.date') }}: {{
                                  data.item.creation_date
                                }}</pre
                              >
                              <pre style="color: #ffffff"
                                >{{ $t('general.amount') }}: $ {{
                                  data.item.amount_advance
                                }} MXN</pre
                              >
                            </span>
                          </v-tooltip>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" round flat @click="close">
                {{ $t('general.cancel') }}
              </v-btn>
              <v-btn @click="saveValidate" color="primary" round depressed :loading="loading" :disabled="loading || editable">
                {{ editedItem.id > 0 ? $t('general.save') : $t('general.create') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <b-tabs pills active-nav-item-class="primary">
        <!-- CREADO -->
        <b-tab :disabled="loadingItems && statusTag !== 'created'" @click="getRequestTags('created', 1)">
          <template variant="primary" v-slot:title>
            <h5 class="my-0">{{ $t('expenses.status.created') }}</h5>
          </template>
          <v-flex>
            <v-toolbar flat color="bg-sidebar" dark>
              <h2 class="my-0">{{ $t('expenses.status.created') }}</h2>
              <v-spacer></v-spacer>
              <v-text-field
                color="light"
                v-model="searchExpense"
                :label="$t('general.searchForClick')"
                append-outer-icon="search"
                @keyup.enter="searching"
                @click:append="searching">
              </v-text-field>
            </v-toolbar>
            <v-data-table
              class="elevation-2 mt-2"
              :headers="headers"
              :items="exCreated"
              :loading="loadingItems"
              :rows-per-page-items="[10, 15, 25]"
              :pagination.sync="pagination"
              :items-per-page="pagination.rowsPerPage"
              :total-items="pagination.totalItems"
              @update:pagination="checkPageChange"
            >
              <template v-slot:headers="props">
                <tr class="bg-heavy-rain">
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column',
                      header.sortable ? 'sortable' : '',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <h2 class="font-weight-black primary--text mb-0">
                      <v-icon small class="primary--text" v-if="header.sortable"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </h2>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <tr v-bind="attrs" v-on="on" @dblclick="detail(props.item.id)">
                      <td class="text-sm-center">
                        <div style="align-items: center;" :style="(props.item.type !== null && props.item.type === 'RESERVATION') || (props.item.type !== null && props.item.type === 'REQUEST') ? 'display: flex;' : ''">
                          <v-tooltip v-if="(props.item.type !== null && props.item.type === 'RESERVATION') || (props.item.type !== null && props.item.type === 'REQUEST')" top>
                          <template v-slot:activator="{ on }">
                            <v-icon style="vertical-align: middle" class="primary--text" v-on="on">mdi-calendar-check-outline</v-icon>
                          </template>
                          <span>{{ $t('expenses.reservationExpType') }}</span>
                        </v-tooltip>
                        <v-tooltip v-if="(props.item.expense_return && props.item.expense_return !== null) || (props.item.expenses_progress.length > 0 && viewExpenseReject(props.item.expenses_progress))" top>
                          <template v-slot:activator="{ on }">
                            <v-icon style="vertical-align: middle" class="error--text" v-on="on">mdi-flag</v-icon>
                          </template>
                          <span>
                            {{ $t('expenses.returnedExpense') }}
                            {{ (props.item.expense_return && props.item.expense_return !== null && props.item.expense_return.comment && ' ' + props.item.expense_return.comment)
                                ||
                              (props.item.expenses_progress.length > 0 && viewExpenseRejectMessage(props.item.expenses_progress))
                            }}
                          </span>
                        </v-tooltip>
                        </div>
                        {{ props.item.id }}
                      </td>
                      <td class="text-sm-center">{{ props.item.start_date }}</td>
                      <td class="text-sm-center">{{ props.item.end_date }}</td>
                      <td class="text-sm-center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              style="vertical-align: middle"
                              v-if="props.item.is_petty_cash === 1"
                              class="primary--text"
                              v-on="on"
                              >stars</v-icon
                            >
                          </template>
                          <span>{{ $t('expenses.pettyExpense') }}</span>
                        </v-tooltip>
                        {{ props.item.description }}
                      </td>
                      <td class="text-sm-center">{{ props.item.project.name }}</td>
                      <td class="text-sm-center">
                        {{ props.item.advance | formatCurrency }}
                      </td>
                      <td class="text-sm-center">
                        {{ props.item.amount | formatCurrency }}
                      </td>
                      <td class="text-sm-center">
                        <v-layout
                          row
                          justify-center
                          v-if="props.item.status_expense.id === 1"
                        >
                          <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                              <v-btn color="primary" dark v-on="on" icon>
                                <v-icon>menu</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-tile @click="getHistory(props.item)">
                                <v-list-tile-avatar>
                                  <v-icon color="info">history</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-title>{{ $t('general.history') }}</v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile v-if="props.item.gst_expenses_items && props.item.gst_expenses_items.length > 0" @click="getAcuse(props.item.id)">
                                <v-list-tile-avatar>
                                  <v-icon color="info">receipt</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-title>{{ $t('expenses.downloadAccuse') }}</v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile @click="detail(props.item.id)">
                                <v-list-tile-avatar>
                                  <v-icon
                                    color="info"
                                    v-if="props.item.type === null"
                                    >add</v-icon
                                  >
                                  <v-icon color="info" v-else>visibility</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-title>{{
                                  props.item.type === null
                                    ? $t('expenseItems.add')
                                    : $t('reportExpenseTracking.seeExpense')
                                }}</v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile :disabled="checkFiscal(props.item.gst_expenses_items) || validationByStatus(props.item)" @click="showWorkflowDialog(props.item)">
                                <v-list-tile-avatar>
                                  <v-icon color="info">play_arrow</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-title>
                                  <span
                                    v-if="
                                      checkFiscal(props.item.gst_expenses_items) ===
                                      true
                                    "
                                    >{{ $t('expenses.xmlPending') }}</span
                                  >
                                  <span v-else>{{
                                    $t('expenses.sendValidation')
                                  }}</span>
                                </v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile v-if="validationByStatus(props.item)" :disabled="true">
                                <v-list-tile-avatar>
                                </v-list-tile-avatar>
                                <v-list-tile-title>
                                  <span v-if="props.item.is_blue_voucher === 1">{{ $t('expenses.blueVoucher.errorValidationAmount') }}</span>
                                  <span v-if="props.item.is_imported_expense === 1">{{ $t('expenses.travelExpense.errorValidationAmount') }}</span>
                                </v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile :disabled="props.item.is_blue_voucher === 1 || validationByStatus(props.item)" @click="editItem(props.item)">
                                <v-list-tile-avatar>
                                  <v-icon color="info">edit</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-title>
                                  {{ $t('general.edit') }}
                                </v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile
                                @click="deleteItem(props.item)"
                                :disabled="
                                  props.item.created_by &&
                                  props.item.created_by.id !== userLogged.id
                                "
                              >
                                <v-list-tile-avatar>
                                  <v-icon color="error">delete</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-title>
                                  {{ $t('general.delete') }}
                                </v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile
                                v-if="props.item.travel_expenses_request !== null"
                                @click="downloadRequest(props.item)"
                              >
                                <v-list-tile-avatar>
                                  <v-icon color="orange" small style="width: 16px"
                                    >fas fa-file-invoice-dollar</v-icon
                                  >
                                </v-list-tile-avatar>
                                <v-list-tile-title>
                                  {{ $t('viatics.downloadRequest') }}
                                </v-list-tile-title>
                              </v-list-tile>
                            </v-list>
                          </v-menu>
                          <section v-if="false">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  small
                                  outline
                                  icon
                                  color="info"
                                  v-on="on"
                                  @click="getHistory(props.item)"
                                >
                                  <v-icon small>history</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('general.history') }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  small
                                  outline
                                  icon
                                  color="info"
                                  v-on="on"
                                  @click="detail(props.item.id)"
                                >
                                  <v-icon small>add</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('expenseItems.add') }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <div v-on="on">
                                  <v-btn
                                    :disabled="
                                      checkFiscal(props.item.gst_expenses_items)
                                    "
                                    small
                                    outline
                                    icon
                                    color="info"
                                    @click="showWorkflowDialog(props.item)"
                                  >
                                    <v-icon small>play_arrow</v-icon>
                                  </v-btn>
                                </div>
                              </template>
                              <span
                                v-if="
                                  checkFiscal(props.item.gst_expenses_items) ===
                                  true
                                "
                                >{{ $t('expenses.xmlPending') }}</span
                              >
                              <span v-else>{{ $t('expenses.sendValidation') }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  small
                                  outline
                                  icon
                                  color="info"
                                  v-on="on"
                                  @click="editItem(props.item)"
                                >
                                  <v-icon small>edit</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('general.edit') }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  :disabled="
                                    props.item.created_by &&
                                    props.item.created_by.id !== userLogged.id
                                  "
                                  small
                                  outline
                                  icon
                                  color="error"
                                  v-on="on"
                                  @click="deleteItem(props.item)"
                                >
                                  <v-icon small>delete</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('general.delete') }}</span>
                            </v-tooltip>
                            <v-tooltip
                              bottom
                              v-if="props.item.travel_expenses_request !== null"
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-if="props.item.travel_expenses_request !== null"
                                  small
                                  outline
                                  icon
                                  color="orange"
                                  v-on="on"
                                  @click="downloadRequest(props.item)"
                                >
                                  <v-icon small>fas fa-file-invoice-dollar</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('viatics.downloadRequest') }}</span>
                            </v-tooltip>
                          </section>
                        </v-layout>
                      </td>
                    </tr>
                  </template>
                  <span>{{ $t('expenseItems.handleRowDoubleClick') }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-flex>
        </b-tab>
        <!-- ENVIADO -->
        <b-tab :disabled="loadingItems && statusTag !== 'sented'" @click="getRequestTags('sented', 2)">
          <template variant="primary" v-slot:title>
            <h5 class="my-0">{{ $t('expenses.status.sented') }}</h5>
          </template>
          <v-flex>
            <v-toolbar flat color="bg-sidebar" dark>
              <h2 class="my-0">{{ $t('expenses.status.sented') }}</h2>
              <v-spacer></v-spacer>
              <v-text-field
                color="light"
                v-model="searchExpense"
                :label="$t('general.searchForClick')"
                clearable
                append-outer-icon="search"
                @keyup.enter="searching"
                @click:append="searching">
              </v-text-field>
            </v-toolbar>
            <v-data-table
              class="elevation-2 mt-2"
              :headers="headers2"
              :items="expenses"
              :loading="loadingItems"
              :rows-per-page-items="[10, 15, 25]"
              :pagination.sync="pagination"
              :items-per-page="pagination.rowsPerPage"
              :total-items="pagination.totalItems"
              @update:pagination="checkPageChange"
            >
              <template v-slot:headers="props">
                <tr class="bg-heavy-rain">
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column',
                      header.sortable ? 'sortable' : '',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <h2 class="font-weight-black primary--text mb-0">
                      <v-icon small class="primary--text" v-if="header.sortable"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </h2>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <tr v-bind="attrs" v-on="on" @dblclick="detailForm(props.item)">
                      <td class="text-sm-center" width="50px">{{ props.item.id }}</td>
                      <td class="text-sm-center">{{ props.item.start_date }}</td>
                      <td class="text-sm-center">{{ props.item.end_date }}</td>
                      <td class="text-sm-center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              style="vertical-align: middle"
                              v-if="props.item.is_petty_cash === 1"
                              class="primary--text"
                              v-on="on"
                              >stars</v-icon
                            >
                          </template>
                          <span>{{ $t('expenses.pettyExpense') }}</span>
                        </v-tooltip>
                        {{ props.item.description }}
                      </td>
                      <td class="text-sm-center">{{ props.item.project.name }}</td>
                      <td class="text-sm-center">
                        {{ props.item.advance | formatCurrency }}
                      </td>
                      <td class="text-sm-center">
                        {{ props.item.amount | formatCurrency }}
                      </td>
                      <td class="text-sm-center tdSize">
                        <v-layout row class="d-inline-flex">
                          <v-flex class="btnStyle">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getAcuse(props.item.id)">
                                <v-icon small>receipt</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('expenses.downloadAccuse') }}</span>
                          </v-tooltip>
                          </v-flex>
                          <v-flex class="btnStyle">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getHistory(props.item)">
                                <v-icon small>history</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('general.history') }}</span>
                          </v-tooltip>
                          </v-flex>
                          <v-flex class="btnStyle">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn :loading="loadingExcelReport === props.item.id" small outline icon class="size-btn" color="green" v-on="on" @click="downloadExcelReport(props.item)">
                                <v-icon small>mdi-file-excel</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('viatics.downloadExcelReport') }}</span>
                          </v-tooltip>
                          </v-flex>
                          <v-flex class="btnStyle" v-if="props.item.travel_expenses_request !== null">
                          <v-tooltip
                            bottom
                            v-show="props.item.travel_expenses_request !== null"
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-if="props.item.travel_expenses_request !== null"
                                small
                                outline
                                icon
                                class="size-btn"
                                color="orange"
                                v-on="on"
                                @click="downloadRequest(props.item)"
                              >
                                <v-icon small>fas fa-file-invoice-dollar</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('viatics.downloadRequest') }}</span>
                          </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </td>
                    </tr>
                  </template>
                  <!-- ENVIADOS -->
                  <span>{{ $t('expenseItems.handleRowDoubleClick') }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-flex>
        </b-tab>
        <!-- REVISADO -->
        <b-tab :disabled="loadingItems && statusTag !== 'reviewed'" @click="getRequestTags('reviewed', 3)">
          <template variant="primary" v-slot:title>
            <h5 class="my-0">{{ $t('expenses.status.reviewed') }}</h5>
          </template>
          <v-flex>
            <v-toolbar flat color="bg-sidebar" dark>
              <h2 class="my-0">{{ $t('expenses.status.reviewed') }}</h2>
              <v-spacer></v-spacer>
              <v-text-field
                color="light"
                v-model="searchExpense"
                :label="$t('general.searchForClick')"
                clearable
                append-outer-icon="search"
                @keyup.enter="searching"
                @click:append="searching">
              </v-text-field>
            </v-toolbar>
            <v-data-table
              class="elevation-2 mt-2"
              :headers="headers2"
              :items="expenses"
              :loading="loadingItems"
              :rows-per-page-items="[10, 15, 25]"
              :pagination.sync="pagination"
              :items-per-page="pagination.rowsPerPage"
              :total-items="pagination.totalItems"
              @update:pagination="checkPageChange"
            >
              <template v-slot:headers="props">
                <tr class="bg-heavy-rain">
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column',
                      header.sortable ? 'sortable' : '',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <h2 class="font-weight-black primary--text mb-0">
                      <v-icon small class="primary--text" v-if="header.sortable"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </h2>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <tr v-bind="attrs" v-on="on" @dblclick="detailForm(props.item)">
                      <td width="60px">{{ props.item.id }}</td>
                      <td class="text-sm-center">{{ props.item.start_date }}</td>
                      <td class="text-sm-center">{{ props.item.end_date }}</td>
                      <td class="text-sm-center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              style="vertical-align: middle"
                              v-if="props.item.is_petty_cash === 1"
                              class="primary--text"
                              v-on="on"
                              >stars</v-icon
                            >
                          </template>
                          <span>{{ $t('expenses.pettyExpense') }}</span>
                        </v-tooltip>
                        {{ props.item.description }}
                      </td>
                      <td class="text-sm-center">{{ props.item.project.name }}</td>
                      <td class="text-sm-center">
                        {{ props.item.advance | formatCurrency }}
                      </td>
                      <td class="text-sm-center">
                        {{ props.item.amount | formatCurrency }}
                      </td>
                      <td class="text-sm-center tdSize">
                        <v-layout row class="d-inline-flex">
                          <v-flex class="btnStyle">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getAcuse(props.item.id)">
                                  <v-icon small>receipt</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('expenses.downloadAccuse') }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getHistory(props.item)">
                                <v-icon small>history</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('general.history') }}</span>
                          </v-tooltip>
                          <v-flex class="btnStyle">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn :loading="loadingExcelReport === props.item.id" small outline icon class="size-btn" color="green" v-on="on" @click="downloadExcelReport(props.item)">
                                <v-icon small>mdi-file-excel</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('viatics.downloadExcelReport') }}</span>
                          </v-tooltip>
                          </v-flex>
                          <v-tooltip
                            bottom
                            v-if="props.item.travel_expenses_request !== null"
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-if="props.item.travel_expenses_request !== null"
                                :disabled="
                                  props.item.created_by &&
                                  props.item.created_by.id !== userLogged.id
                                "
                                small
                                outline
                                icon
                                color="orange"
                                v-on="on"
                                @click="downloadRequest(props.item)"
                              >
                                <v-icon small>fas fa-file-invoice-dollar</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('viatics.downloadRequest') }}</span>
                          </v-tooltip>
                      </v-layout>
                      </td>
                    </tr>
                  </template>
                  <!-- REVISADOS -->
                  <span>{{ $t('expenseItems.handleRowDoubleClick') }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-flex>
        </b-tab>
        <!-- POR PAGAR -->
        <b-tab :disabled="loadingItems && statusTag !== 'payable'" @click="getRequestTags('payable', 4)">
          <template variant="primary" v-slot:title>
            <h5 class="my-0">{{ $t('expenses.status.payable') }}</h5>
          </template>
          <v-flex>
            <v-toolbar flat color="bg-sidebar" dark>
              <h2 class="my-0">{{ $t('expenses.status.payable') }}</h2>
              <v-spacer></v-spacer>
              <v-text-field
                color="light"
                v-model="searchExpense"
                :label="$t('general.searchForClick')"
                clearable
                append-outer-icon="search"
                @keyup.enter="searching"
                @click:append="searching">
              </v-text-field>
            </v-toolbar>
            <v-data-table
              class="elevation-2 mt-2"
              :headers="headers2"
              :items="expenses"
              :loading="loadingItems"
              :rows-per-page-items="[10, 15, 25]"
              :pagination.sync="pagination"
              :items-per-page="pagination.rowsPerPage"
              :total-items="pagination.totalItems"
              @update:pagination="checkPageChange"
            >
              <template v-slot:headers="props">
                <tr class="bg-heavy-rain">
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column',
                      header.sortable ? 'sortable' : '',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <h2 class="font-weight-black primary--text mb-0">
                      <v-icon small class="primary--text" v-if="header.sortable"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </h2>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <tr v-bind="attrs" v-on="on" @dblclick="detailForm(props.item)">
                      <td width="60px">{{ props.item.id }}</td>
                      <td class="text-sm-center">{{ props.item.start_date }}</td>
                      <td class="text-sm-center">{{ props.item.end_date }}</td>
                      <td class="text-sm-center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              style="vertical-align: middle"
                              v-if="props.item.is_petty_cash === 1"
                              class="primary--text"
                              v-on="on"
                              >stars</v-icon
                            >
                          </template>
                          <span>{{ $t('expenses.pettyExpense') }}</span>
                        </v-tooltip>
                        {{ props.item.description }}
                      </td>
                      <td class="text-sm-center">{{ props.item.project.name }}</td>
                      <td class="text-sm-center">
                        {{ props.item.advance | formatCurrency }}
                      </td>
                      <td class="text-sm-center">
                        {{ props.item.amount | formatCurrency }}
                      </td>
                      <td class="text-sm-center tdSize">
                        <v-layout row class="d-inline-flex">
                          <v-flex class="btnStyle">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getAcuse(props.item.id)">
                                <v-icon small>receipt</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('expenses.downloadAccuse') }}</span>
                          </v-tooltip>
                          </v-flex>
                          <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getHistory(props.item)">
                              <v-icon small>history</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('general.history') }}</span>
                        </v-tooltip>
                          <v-flex class="btnStyle">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn :loading="loadingExcelReport === props.item.id" small outline icon class="size-btn" color="green" v-on="on" @click="downloadExcelReport(props.item)">
                                <v-icon small>mdi-file-excel</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('viatics.downloadExcelReport') }}</span>
                          </v-tooltip>
                          </v-flex>
                        <v-tooltip
                          bottom
                          v-if="props.item.travel_expenses_request !== null"
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                              :disabled="
                                props.item.created_by &&
                                props.item.created_by.id !== userLogged.id
                              "
                              small
                              outline
                              icon
                              color="orange"
                              v-on="on"
                              @click="downloadRequest(props.item)"
                            >
                              <v-icon small>fas fa-file-invoice-dollar</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('viatics.downloadRequest') }}</span>
                        </v-tooltip>
                        </v-layout>
                      </td>
                    </tr>
                  </template>
                  <!-- POR PAGAR -->
                  <span>{{ $t('expenseItems.handleRowDoubleClick') }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-flex>
        </b-tab>
        <!-- PAGO PARCIAL -->
        <b-tab :disabled="loadingItems && statusTag !== 'payment'" @click="getRequestTags('payment', 5)">
          <template variant="primary" v-slot:title>
            <h5 class="my-0">{{ $t('expenses.status.payment') }}</h5>
          </template>
          <v-flex>
            <v-toolbar flat color="bg-sidebar" dark>
              <h2 class="my-0">{{ $t('expenses.status.payment') }}</h2>
              <v-spacer></v-spacer>
              <v-text-field
                color="light"
                v-model="searchExpense"
                :label="$t('general.searchForClick')"
                clearable
                append-outer-icon="search"
                @keyup.enter="searching"
                @click:append="searching">
              </v-text-field>
            </v-toolbar>
            <v-data-table
              class="elevation-2 mt-2"
              :headers="headers2"
              :items="expenses"
              :loading="loadingItems"
              :rows-per-page-items="[10, 15, 25]"
              :pagination.sync="pagination"
              :items-per-page="pagination.rowsPerPage"
              :total-items="pagination.totalItems"
              @update:pagination="checkPageChange"
            >
              <template v-slot:headers="props">
                <tr class="bg-heavy-rain">
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column',
                      header.sortable ? 'sortable' : '',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <h2 class="font-weight-black primary--text mb-0">
                      <v-icon small class="primary--text" v-if="header.sortable"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </h2>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <tr v-bind="attrs" v-on="on" @dblclick="detailForm(props.item)">
                      <td width="60px">{{ props.item.id }}</td>
                      <td class="text-sm-center">{{ props.item.start_date }}</td>
                      <td class="text-sm-center">{{ props.item.end_date }}</td>
                      <td class="text-sm-center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              style="vertical-align: middle"
                              v-if="props.item.is_petty_cash === 1"
                              class="primary--text"
                              v-on="on"
                              >stars</v-icon
                            >
                          </template>
                          <span>{{ $t('expenses.pettyExpense') }}</span>
                        </v-tooltip>
                        {{ props.item.description }}
                      </td>
                      <td class="text-sm-center">{{ props.item.project.name }}</td>
                      <td class="text-sm-center">
                        {{ props.item.advance | formatCurrency }}
                      </td>
                      <td class="text-sm-center">
                        {{ props.item.amount | formatCurrency }}
                      </td>
                      <td class="text-sm-center tdSize">
                        <v-layout row class="d-inline-flex">
                          <v-flex class="btnStyle">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getAcuse(props.item.id)">
                                <v-icon small>receipt</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('expenses.downloadAccuse') }}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getHistory(props.item)">
                              <v-icon small>history</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('general.history') }}</span>
                        </v-tooltip>
                        <v-flex class="btnStyle">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn :loading="loadingExcelReport === props.item.id" small outline icon class="size-btn" color="green" v-on="on" @click="downloadExcelReport(props.item)">
                              <v-icon small>mdi-file-excel</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('viatics.downloadExcelReport') }}</span>
                        </v-tooltip>
                        </v-flex>
                        <v-tooltip
                          bottom
                          v-if="props.item.travel_expenses_request !== null"
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-if="props.item.travel_expenses_request !== null"
                              :disabled="
                                props.item.created_by &&
                                props.item.created_by.id !== userLogged.id
                              "
                              small
                              outline
                              icon
                              color="orange"
                              v-on="on"
                              @click="downloadRequest(props.item)"
                            >
                              <v-icon small>fas fa-file-invoice-dollar</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('viatics.downloadRequest') }}</span>
                        </v-tooltip>
                        </v-layout>
                      </td>
                    </tr>
                  </template>
                  <!-- PAGO PARCIAL -->
                  <span>{{ $t('expenseItems.handleRowDoubleClick') }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-flex>
        </b-tab>
        <!-- COMPLETADO -->
        <b-tab :disabled="loadingItems && statusTag !== 'paid'" @click="getRequestTags('paid', 6)">
          <template variant="primary" v-slot:title>
            <h5 class="my-0">{{ $t('expenses.status.paid') }}</h5>
          </template>
          <v-flex>
            <v-toolbar flat color="bg-sidebar" dark>
              <h2 class="my-0">{{ $t('expenses.status.paid') }}</h2>
              <v-spacer></v-spacer>
              <v-text-field
                color="light"
                v-model="searchExpense"
                :label="$t('general.searchForClick')"
                clearable
                append-outer-icon="search"
                @keyup.enter="searching"
                @click:append="searching">
              </v-text-field>
            </v-toolbar>
            <v-data-table
              class="elevation-2 mt-2"
              :headers="headers2"
              :items="expenses"
              :loading="loadingItems"
              :rows-per-page-items="[10, 15, 25]"
              :pagination.sync="pagination"
              :items-per-page="pagination.rowsPerPage"
              :total-items="pagination.totalItems"
              @update:pagination="checkPageChange"
            >
              <template v-slot:headers="props">
                <tr class="bg-heavy-rain">
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column',
                      header.sortable ? 'sortable' : '',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <h2 class="font-weight-black primary--text mb-0">
                      <v-icon small class="primary--text" v-if="header.sortable"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </h2>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <tr v-bind="attrs" v-on="on" @dblclick="detailForm(props.item)">
                      <td width="60px">{{ props.item.id }}</td>
                      <td class="text-sm-center">{{ props.item.start_date }}</td>
                      <td class="text-sm-center">{{ props.item.end_date }}</td>
                      <td class="text-sm-center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              style="vertical-align: middle"
                              v-if="props.item.is_petty_cash === 1"
                              class="primary--text"
                              v-on="on"
                              >stars</v-icon
                            >
                          </template>
                          <span>{{ $t('expenses.pettyExpense') }}</span>
                        </v-tooltip>
                        {{ props.item.description }}
                      </td>
                      <td class="text-sm-center">{{ props.item.project.name }}</td>
                      <td class="text-sm-center">
                        {{ props.item.advance | formatCurrency }}
                      </td>
                      <td class="text-sm-center">
                        {{ props.item.amount | formatCurrency }}
                      </td>
                      <td class="text-sm-center tdSize">
                        <v-layout row class="d-inline-flex">
                          <v-flex class="btnStyle10Px">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getAcuse(props.item.id)">
                                  <v-icon small>receipt</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('expenses.downloadAccuse') }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex class="btnStyle10Px">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getHistory(props.item)">
                                  <v-icon small>history</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('general.history') }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex class="btnStyle10Px">
                            <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn :loading="loadingExcelReport === props.item.id" small outline icon class="size-btn" color="green" v-on="on" @click="downloadExcelReport(props.item)">
                                <v-icon small>mdi-file-excel</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('viatics.downloadExcelReport') }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex class="btnStyle10Px" v-if="props.item.travel_expenses_request !== null">
                            <v-tooltip bottom >
                              <template v-slot:activator="{ on }">
                                <v-btn v-if="props.item.travel_expenses_request !== null"
                                  :disabled="props.item.created_by && props.item.created_by.id !== userLogged.id"
                                  small outline icon color="orange" v-on="on" @click="downloadRequest(props.item)">
                                  <v-icon small>fas fa-file-invoice-dollar</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('viatics.downloadRequest') }}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </td>
                    </tr>
                  </template>
                  <!-- COMPLETADAS -->
                  <span>{{ $t('expenseItems.handleRowDoubleClick') }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-flex>
        </b-tab>
      </b-tabs>
      <v-dialog persistent v-model="removeDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">
              {{ $t('expenses.delete') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black">
              <span class="error--text">{{ $t('expenses.description') }}: </span
              >{{ editedItem.description }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="removeItem"
            >
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="workflowDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.sendValidation') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('expenses.sendValidationMessage') }}</p>
            <p class="font-weight-black">
              <span class="primary--text"
                >{{ $t('expenses.description') }}: </span
              >{{ editedItem.description }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="closeWorkflowDialog"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              round
              depressed
              :loading="loading"
              :disabled="loading"
              @click="doStartWorkflow"
            >
              {{ $t('expenses.start') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="confirmSave" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.edit') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('expenses.sendValidationMultiProject') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="confirmSave = false" color="primary darken-1" round flat>
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn @click="save" color="primary" round depressed :loading="loading" :disabled="loading">
              {{ $t('general.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="workflowDialogValidate" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.blueVoucher.errorWorkFlow') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('expenses.blueVoucher.errorFile') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="workflowDialogValidate=false"
            >
              {{ $t('general.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="histDialog" max-width="900px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.tracking') }}
            </h2>
          </v-toolbar>
          <v-card-text v-if="histLoading">
            <v-layout>
              <v-flex class="text-center">
                <v-progress-circular color="primary" indeterminate size="50" />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text v-if="!histLoading">
            <v-layout wrap>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black">{{ $t('workflowValidation.expenseNo') }}: </span>{{ histItem.id }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black">{{ $t('general.workflow') }}: </span>{{ workflowName }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black">{{ $t('general.description') }}: </span>{{ histItem.description }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black">{{ $t('general.project') }}: </span>{{ histItem.project.name }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black">{{ $t('general.startDate') }}: </span>{{ histItem.start_date }}</h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black">{{ $t('general.endDate') }}: </span>{{ histItem.end_date }}
                </h3>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-divider />
                <h3 class="primary--text font-weight-black">
                  {{ $t('expenses.progress') }}:
                </h3>
                <v-card flat color="grey lighten-3">
                  <v-layout>
                    <v-flex class="text-center py-3" :class="histSteps.sented.length > 0 ? 'hist-steps white--text' : 'grey--text'" xs4>
                      <v-avatar class="mr-2" size="20" :color="histSteps.sented.length > 0 ? 'white' : 'grey'">
                        <v-icon v-if="histSteps.sented.length > 0" class="font-weight-black" small>check</v-icon>
                        <span v-else class="white--text font-weight-black">1</span>
                      </v-avatar>
                      <span class="font-weight-black my-3">{{ $t('expenses.exs.sented') }}</span>
                    </v-flex>
                    <v-divider vertical />
                    <v-flex class="text-center py-3" :class="histSteps.reviewed.length > 0 ? 'hist-steps white--text' : 'grey--text'" xs4>
                      <v-avatar class="mr-2" size="20" :color="histSteps.reviewed.length > 0 ? 'white' : 'grey'">
                        <v-icon v-if="histSteps.reviewed.length > 0" class="font-weight-black" small>check</v-icon>
                        <span v-else class="white--text font-weight-black">2</span>
                      </v-avatar>
                      <span class="font-weight-black my-3">{{ $t('expenses.exs.reviewed') }}</span>
                    </v-flex>
                    <v-divider vertical />
                    <v-flex class="text-center py-3" :class="histSteps.payable.length ? 'hist-steps white--text' : 'grey--text'" xs4>
                      <v-avatar class="mr-2" size="20" :color="histSteps.payable.length ? 'white' : 'grey'">
                        <v-icon v-if="histSteps.payable.length" class="font-weight-black" small>check</v-icon>
                        <span v-else class="white--text font-weight-black">3</span>
                      </v-avatar>
                      <span class="font-weight-black my-3">{{ $t('expenses.exs.approved') }}</span>
                    </v-flex>
                    <v-divider vertical />
                    <v-flex class="text-center py-3" :class="histSteps.paid.length ? 'hist-steps white--text' : 'grey--text'" xs4>
                      <v-avatar class="mr-2" size="20" :color="histSteps.paid.length ? 'white' : 'grey'">
                        <v-icon v-if="histSteps.paid.length" class="font-weight-black" small>check</v-icon>
                        <span v-else class="white--text font-weight-black">4</span>
                      </v-avatar>
                      <span class="font-weight-black my-3">{{ $t('expenses.exs.paid') }}</span>
                    </v-flex>
                  </v-layout>
                  <v-divider class="my-0 primary" />
                  <v-layout>
                    <v-flex v-if="histSteps.sented.length > 0" class="text-center pa-3" xs4>
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.sented') }}:
                      </h3>
                      <li class="text-sm-left">
                        {{ histSteps.sented[0].user.name + ' - ' + histSteps.sented[0].created_at }}
                      </li>
                    </v-flex>
                    <v-flex v-else class="text-center pa-3" xs4>
                      <h3 class="grey--text font-weight-black py-2">
                        {{ $t('expenses.history.pending') }}
                      </h3>
                    </v-flex>
                    <v-divider class="primary" vertical />
                    <v-flex v-if="histSteps.reviewed.length > 0" class="text-center pa-3" xs4>
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.reviewed') }}:
                      </h3>
                      <li v-for="step of histSteps.reviewed" :key="step.id" class="text-sm-left">
                        {{ step.user.name + ' - ' + step.created_at }}
                      </li>
                      <v-flex v-if="validatorsExpenses !== null && isApproved === false">
                        <h3 v-if="pendingValidators.length > 0" class="grey--text font-weight-black py-2">
                          {{ $t('expenses.history.pending') }}
                        </h3>
                        <ul v-for="validator of pendingValidators" :key="validator.validator.user_id" class="text-sm-left">
                          <h6 class="text-center font-weight-black">
                            {{ $t('validator.name') }} {{ validator.validatorId }}
                          </h6>
                          {{ validator.validator.user.name }}
                          <h6 v-if="validator.substitutes !== null" class="text-center grey--text pt-1">
                            {{ $t('general.substitutes') }}
                          </h6>
                          <li v-if="validator.substitutes !== null" class="text-sm-left grey--text">
                            {{ validator.substitutes.user.name }}
                          </li>
                        </ul>
                        <v-spacer></v-spacer>
                      </v-flex>
                    </v-flex>
                    <v-flex v-else class="text-center pa-3" xs4>
                      <h3
                        class="grey--text font-weight-black py-2"
                        v-if="validators.length > 0"
                      >
                        {{ $t('expenses.history.pending') }}
                      </h3>
                      <ul v-for="validator of validators" :key="validator.id">
                        <h6 class="text-center font-weight-black">
                          {{ $t('validator.name') }} {{ validator.validatorId }}
                        </h6>
                        <li class="text-sm-left grey--text">
                          {{ validator.validator.user.name }}
                        </li>
                        <h6
                          v-if="validator.substitutes !== null"
                          class="text-center grey--text pt-1"
                        >
                          {{ $t('general.substitutes') }}
                        </h6>
                        <li
                          v-if="validator.substitutes !== null"
                          class="text-sm-left grey--text"
                        >
                          {{ validator.substitutes.user.name }}
                        </li>
                        <v-spacer></v-spacer>
                      </ul>
                    </v-flex>
                    <!-- APROBADORES -->
                    <v-divider class="primary" vertical />
                    <v-flex v-if="histSteps.payable.length > 0" class="text-center pa-3" xs4>
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.payable') }}:
                      </h3>
                      <li class="text-sm-left" v-for="step of histSteps.payable" :key="step.id">
                        {{ step.user.name + ' - ' + step.created_at }}
                      </li>
                    </v-flex>
                    <v-flex v-else-if="approvers.length > 0" class="text-center pa-3" xs4>
                      <h3 class="grey--text font-weight-black py-2">
                        {{ $t('expenses.history.pending') }}
                      </h3>
                      <ul v-for="approver of approvers" :key="approver.id">
                        <li class="text-sm-left grey--text">
                          {{ approver.users[0].name }}
                        </li>
                      </ul>
                    </v-flex>
                    <v-flex v-else class="text-center pa-3" xs4>
                      <h3 class="grey--text font-weight-black py-2">
                        {{ $t('expenses.noApproverDefault') }}
                      </h3>
                    </v-flex>
                    <!-- COMPLETADOS -->
                    <v-divider class="primary" vertical />
                    <v-flex
                      v-if="histSteps.paid.length > 0"
                      class="text-center pa-3"
                      xs4
                    >
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.paid') }}:
                      </h3>
                      <li
                        class="text-sm-left"
                        v-for="step of histSteps.paid"
                        :key="step.id"
                      >
                        {{ step.user.name + ' - ' + step.created_at }}
                      </li>
                    </v-flex>
                    <v-flex v-else-if="approvers.length > 0" class="text-center pa-3" xs4>
                      <h3 class="grey--text font-weight-black py-2">
                        {{ $t('expenses.history.pending') }}
                      </h3>
                      <ul v-for="approver of approvers" :key="approver.id">
                        <li class="text-sm-left grey--text">
                          <!-- {{ approver.users[0].name }} -->
                          <!-- ÚNICO CASO ARLETTE -->
                          {{ (userLogged && userLogged.company && userLogged.company[0] && (userLogged.company[0].id === 49 || userLogged.company[0].id === 50)) ? 'BARAJAS PEREZ ARLETTE DANIELA' : approver.users[0].name }}
                        </li>
                      </ul>
                    </v-flex>
                    <v-flex v-else class="text-center pa-3" xs4>
                      <h3 class="grey--text font-weight-black py-2">
                        {{ $t('expenses.noApproverDefault') }}
                      </h3>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" round flat @click="close">
              {{ $t('general.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogForm" scrollable max-width="900px" persistent>
        <v-card>
          <!-- BOTONES ACCIÓN -->
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('workflowValidation.item') }}{{ editedItemView.id }}
              <span>({{ editedItemView.receipt_type ? editedItemView.receipt_type.name : '' }})</span>
            </h2>
            <v-btn v-if="editedItemView.item_lines && editedItemView.item_lines.length > 0" @click="showEditCategory" round flat color="primary" class="marginLeft" >
              <v-icon left>list</v-icon> {{ titleTagCategory }}
            </v-btn>
            <v-btn v-if="receipt_type === 1" :disabled="!cfdiHtml" round flat color="primary" @click="sendToPrint()">
              <v-icon left>print</v-icon> {{ $t('general.print') }}
            </v-btn>
            <v-flex class="text-right">
              <v-btn :disabled="expensesItems.length <= 1" small icon outline color="primary" @click="viewPrevious(editedItemView.id)" class="mx-5">
                <v-icon small>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn :disabled="expensesItems.length <= 1" small icon outline color="primary" @click="viewNext(editedItemView.id)" class="mx-5">
                <v-icon small>mdi-arrow-right</v-icon>
              </v-btn>
              <v-btn small icon color="error" @click="closeView" class="ml-5">
                <v-icon small>clear</v-icon>
              </v-btn>
            </v-flex>
          </v-toolbar>
          <!-- FISCAL -->
          <v-card-text v-if="!editCategory && receipt_type === 1">
            <iframe name="cfdi" :srcdoc="cfdiHtml" style="width: 845px; height: 1200px; border: 0"></iframe>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-form lazy-validation ref="formf" v-model="valid">
                  <v-flex xs12 md6>
                    <v-select v-model="editedItemView.gst_categories_id" :label="$t('categories.name')" required :items="categories" item-value="id" item-text="name" class="mr-3" :rules="rules.required" :error-messages="errors.gst_category_id" disabled></v-select>
                  </v-flex>
                </v-form>
                <v-flex xs12 md6>
                   <v-textarea v-model="editedItemView.comment" :label="$t('general.comment')" disabled outline></v-textarea>
                </v-flex>
                <h2 class="font-weight-black primary--text mb-0 flex xs12">
                  {{ formTitleTip }}
                </h2>
                <v-form v-if="editedItemTip.created_at !== ''" ref="tipForm" lazy-validation>
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field v-model="editedItemTip.amount" :error-messages="errors.amount" :rules="rules.required" :label="$t('general.amount')"></v-text-field>
                      </v-flex>
                      <v-flex v-if="dataURL">
                        <v-flex xs12>
                          <label>{{ $t('expenses.file') }}:</label>
                          <a v-if="!isPDF(dataURL)" @click="openPDF()">
                            <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                          </a>
                          <v-btn block v-if="isPDF(dataURL)" @click="openPDF()" color="primary" depressed>
                            <v-icon left>insert_drive_file</v-icon>
                            {{ $t('expenseItems.watchFile') }}
                          </v-btn>
                          <iframe v-if="isPDF(dataURL)" :src="dataURL" frameborder="0" width="100%" height="400px"></iframe>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-layout>
            </v-container>
          </v-card-text>
          <!-- NO FISCAL / UNIVERSAL -->
          <v-card-text v-if="!editCategory && receipt_type !== 1">
            <v-form lazy-validation ref="form" v-model="valid">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex layout row wrap v-bind:class="{ xs6: dataURL }">
                    <v-flex xs12>
                      <v-text-field v-model="editedItemView.date" :label="$t('general.date')" disabled prepend-icon="event"></v-text-field>
                    </v-flex>
                    <v-flex v-if="editedItemView.country" xs12 md6>
                      <v-text-field v-model="editedItemView.country.descripcion" :label="$t('general.country')" disabled prepend-icon="location_on"></v-text-field>
                    </v-flex>
                    <v-flex v-if="editedItemView.gst_categories" xs12 md6>
                      <v-text-field v-model="editedItemView.gst_categories.name" :label="$t('categories.name')" disabled prepend-icon="list"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea v-model="editedItemView.description" :label="$t('general.description')" disabled prepend-icon="forum"></v-textarea>
                    </v-flex>
                    <v-flex v-if="editedItemView.currency" xs12 md6>
                      <v-text-field v-model="editedItemView.currency.descripcion" :label="$t('general.currency')" disabled prepend-icon="paid"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field v-model="editedItemView.exchange" :label="$t('general.exchangeRate')" disabled prepend-icon="currency_exchange"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 v-if="editedItemView.gst_receipt_types_id === 3">
                      <v-text-field v-model="editedItemView.vendor.name" :label="$t('general.supplier')" disabled prepend-icon="store"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field v-model="editedItemView.subtotal" :label="$t('general.subtotal')" disabled prepend-icon="attach_money"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field v-model="editedItemView.total" :label="$t('general.total')" disabled prepend-icon="attach_money"></v-text-field>
                    </v-flex>
                    <v-flex v-if="editedItemView.sat_forma_pago" xs12 md6>
                      <v-text-field v-model="editedItemView.sat_forma_pago.descripcion" :label="$t('general.formaPago')" disabled prepend-icon="credit_card"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field v-model="editedItemView.folio" :label="$t('general.folioRef')" disabled prepend-icon="article"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea v-model="editedItemView.comment" :label="$t('general.comment')" disabled prepend-icon="3p"></v-textarea>
                    </v-flex>
                  </v-flex>
                  <v-flex xs6 layout v-if="dataURL">
                    <v-flex xs12>
                      <a v-if="!isPDF(dataURL)" @click="openPDF()">
                        <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                      </a>
                      <iframe v-if="isPDF(dataURL)" :src="dataURL" frameborder="0" width="100%" height="400px"></iframe>
                      <v-btn v-if="isPDF(dataURL)" @click="openPDF()" block color="primary" depressed>
                        <v-icon left>insert_drive_file</v-icon>
                        {{ $t('expenseItems.watchFile') }}
                      </v-btn>
                    </v-flex>
                  </v-flex>
                  <h2 class="font-weight-black primary--text mb-0 flex xs12">
                    {{ formTitleTip }}
                  </h2>
                  <v-form v-if="editedItemTip.created_at !== ''" ref="tipForm" lazy-validation>
                    <v-container>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-text-field v-model="editedItemTip.amount" :label="$t('general.amount')" :error-messages="errors.amount" :rules="rules.required"></v-text-field>
                        </v-flex>
                        <v-flex xs12 layout v-if="dataURL">
                          <v-flex xs12>
                            <label>{{ $t('expenses.file') }}:</label>
                            <a v-if="!isPDF(dataURL)" @click="openPDF()">
                              <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                            </a>
                            <v-btn v-if="isPDF(dataURL)" @click="openPDF()" color="primary" block depressed>
                              <v-icon left>insert_drive_file</v-icon>
                              {{ $t('expenseItems.watchFile') }}
                            </v-btn>
                            <iframe v-if="isPDF(dataURL)" :src="dataURL" frameborder="0" width="100%" height="400px"></iframe>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <!-- CATEGORÍAS -->
          <v-card-text v-if="editCategory">
            <v-layout>
              <v-flex md12>
                <h3 class="font-weight-black primary--text mb-0">{{ $t('general.concepts') }}</h3>
                <v-layout>
                    <v-data-table style="width: 100%;" :headers="conceptsHeaderLines" :items="concepts"  loading-text="Cargando contenido" :footer-props="{ 'items-per-page-options': [-1] }" hide-default-footer no-data-text="No hay datos que mostrar" disable-pagination hide-actions>
                      <template v-slot:items="props">
                        <tr>
                          <td class="text-sm-left text-truncate" style="width: 40%">
                            <v-textarea class="text-sm-center dynamic-textarea" rows="1"  auto-grow outlined dense :hide-details="true" color="primary" v-model="props.item.line"  type="text" :disabled="true"/>
                          </td>
                          <td style="width: 15%">
                            <span>${{ props.item.amount }}</span>
                          </td>
                          <td style="width: 10%" class="text-sm-center">
                            <span v-if="props.item.line_taxes.length > 0"> {{ props.item.line_taxes[0].rate }}</span>
                            <span v-else>N/A</span>
                          </td>
                          <td style="width: 35%">
                            <v-autocomplete  class="text-sm-center"  v-model="props.item.gst_category_id" item-text="name" item-value="id" dense hide-details :disabled="true"  :rules="rules.required" :items="categories"  color="primary" />
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" flat round class="white--text" depressed @click="closeView">
              {{ $t('general.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faPlaneDeparture,
  faFileInvoiceDollar,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faPlaneDeparture, faFileInvoiceDollar)
export default {
  name: 'expensesComponent',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
  },
  data() {
    return {
      tagMoneda: '',
      settings: {},
      currencySetting: {},
      loadingExcelReport: false,
      ifViatics: false,
      totalPending: 0,
      expense_type: 'small_box',
      filter_by: 'user',
      searchExpense: '',
      isPettyCash: false,
      isDisabledPettyCash: false,
      isDisabledOkBlue: false,
      isDisabledAdvance: false,
      isDisabledRefund: false,
      isDisabledAmexCard: false,
      type: 'refund',
      errors: {},
      loading: false,
      loadingItems: true,
      histLoading: false,
      pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
      defaultPagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
      timeout: 3000,
      dialog: false,
      histDialog: false,
      removeDialog: false,
      workflowDialog: false,
      start: false,
      end: false,
      valid: true,
      editedIndex: -1,
      editedItem: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        project_list: [],
        has_multiprojects: false,
        status: '',
        expenses_status: '',
        advance: 0,
        is_petty_cash: false,
        viatic_request_id: null,
        has_request: false,
        currency: {},
        isVoucherAmount: false,
        voucher_amount: 0
      },
      defaultItem: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        project_list: [],
        has_multiprojects: false,
        status: '',
        expenses_status: '',
        advance: 0,
        is_petty_cash: false,
        viatic_request_id: null,
        has_request: false,
        currency: {},
        isVoucherAmount: false,
        voucher_amount: 0
      },
      histItem: {
        id: 1,
        description: 'alguna vaina',
        start_date: '',
        end_date: '',
        project: {
          name: '',
        },
        progress: [],
        steps: [
          {
            status: 1,
            validator: [
              {
                id: 1,
                name: 'fulano',
              },
              {
                id: 2,
                name: 'fulano',
              },
            ],
          },
          {
            status: 2,
            validator: [
              {
                id: 1,
                name: 'fulano',
              },
            ],
          },
        ],
      },
      histSteps: {
        sented: [],
        reviewed: [],
        payable: [],
        paid: [],
      },
      userLogged: {},
      expenses: [],
      exCreated: [],
      exSented: [],
      exReviewed: [],
      exPayable: [],
      exPayment: [],
      exPaid: [],
      expensesStatus: [],
      validators: [],
      approvers: [],
      viatics: [],
      validatorsExpenses: [],
      workflowName: '',
      projects: [],
      start_date: new Date().toISOString().substr(0, 10),
      end_date: new Date().toISOString().substr(0, 10),
      isApproved: false,
      pendingValidators: [],
      expensesReturned: [],
      workflowDialogValidate: false,
      viewVoucherAmount: false,
      cfdiHtml: null,
      defaultItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: '',
      },
      editedItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: '',
      },
      receipt_type: '',
      dialogForm: false,
      concepts: [],
      editCategory: false,
      titleTagCategory: this.$t('general.category'),
      dataURL: null,
      editedItemView: {},
      expensesItems: [],
      categories: [],
      statusExpense: 1,
      initialPage: true,
      statusTag: 'created',
      selectMultiProject: false,
      projectsSecond: [],
      confirmSave: false
    }
  },
  computed: {
    pettyCashAmount() {
      if (!this.userLogged.small_box) return 0;
  
      const found = this.userLogged.small_box.find(x => x.type === 1)
      
      return found ? found.amount : 0
    },
    amexCardAmount() {
      if (!this.userLogged.small_box) return 0

      const found = this.userLogged.small_box.find(x => x.type === 2)
      
      return found ? found.amount : 0
    },
    minDate() {
      let minDate = ''
      if (
        this.editedItem.start_date !== '' &&
        this.editedItem.start_date !== null
      ) {
        minDate = new Date(this.editedItem.start_date)
          .toISOString()
          .substr(0, 10)
      }
      return minDate
    },
    maxDate() {
      let maxDate = ''
      if (
        this.editedItem.end_date !== '' &&
        this.editedItem.end_date !== null
      ) {
        maxDate = new Date(this.editedItem.end_date).toISOString().substr(0, 10)
      }
      return maxDate
    },
    formTitleTip() {
      if (this.editedItemTip.created_at !== '') {
        return this.$t('expenses.tip')
      } else {
        return ''
      }
    },
    conceptsHeaderLines() {
      return [
      {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false
        },
        {
          text: this.$t('general.amount'),
          value: 'amount',
          sortable: false
        },
        {
          text: this.$t('general.iva'),
          align: 'center',
          value: 'amount',
          sortable: false
        },
        {
          text: this.$t('general.category'),
          align: 'center',
          value: 'category',
          sortable: false
        },
      ]
    },
    heading() {
      return this.$t('general.expenses')
    },
    subheading() {
      return this.$t('expenses.subtitle')
    },
    icon() {
      return 'fas fa-hand-holding-usd fa-fw icon-color'
    },
    formTitle() { 
      return this.editedIndex === -1 ? this.$t('expenses.new') : this.$t('expenses.edit')
    },
    headers() {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        // {
        //   text: this.$t('general.user'),
        //   align: 'center',
        //   value: 'user.name',
        //   sortable: true
        // },
        {
          text: this.$t('general.startDate'),
          align: 'center',
          value: 'start_date',
          sortable: true,
        },
        {
          text: this.$t('general.endDate'),
          align: 'center',
          value: 'end_date',
          sortable: true,
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true,
        },
        {
          text: this.$t('general.project'),
          align: 'center',
          value: 'project.name',
          sortable: true,
        },
        {
          text: this.$t('general.advance'),
          align: 'center',
          value: 'advance',
          sortable: true,
        },
        {
          text: this.$t('general.amount'),
          align: 'center',
          value: 'amount',
          sortable: true,
        },
        // {
        //   text: this.$t('general.status'),
        //   align: 'center',
        //   value: 'status_expense.name',
        //   sortable: true
        // },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    headers2() {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: this.$t('general.startDate'),
          align: 'center',
          value: 'start_date',
          sortable: true,
        },
        {
          text: this.$t('general.endDate'),
          align: 'center',
          value: 'end_date',
          sortable: true,
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true,
        },
        {
          text: this.$t('general.project'),
          align: 'center',
          value: 'project.name',
          sortable: true,
        },
        {
          text: this.$t('general.advance'),
          align: 'center',
          value: 'advance',
          sortable: true,
        },
        {
          text: this.$t('general.amount'),
          align: 'center',
          value: 'amount',
          sortable: true,
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
        },
      ]
    },
    rules() {
      return this.$validationRules()
    },
    editable() {
      if (this.editedIndex > -1) {
        if (
          this.editedItem.created_by &&
          this.editedItem.created_by.id !== this.$store.state.userLogged.id
        ) {
          return true
        } else {
          return false
        }
      }
    },
    hasMultiProjects(){
      if(this.$store.state.userLogged && this.$store.state.userLogged.company[0].features.find(x => x.name === 'MULTIPROJECTS')) return true
      
      return false
    }
  },
  watch: {
    'editedItem.project_id'() {
      this.projectsSecond =  this.projects.filter(project => project.id !== this.editedItem.project_id)
    },
    projects(){
      this.projectsSecond =  this.projects
    },
    settings() {
      this.filterCurrency()
    },
    'editedItem.has_request'(val) {
      if (!val) {
        this.editedItem.viatic_request_id = null
      }
    },
    dialog(val) {
      val || this.close()
    },
    validators() {
      this.getPendingValidators()
    },
    removeDialog(val) {
      val || this.closeRemove()
    },
    userLogged() {
      this.get()
      this.getViatics()
      this.$emit('getProjects', {
        id: this.userLogged.company[0].id,
        context: this,
      })
      this.$emit('getViatics', {
        id: this.userLogged.id,
        status: 'APPROVED',
        context: this,
      })
    },
    '$store.state.userLogged'() {
      this.getLogged()
    },
    expenses() {
      this.byCreated()
    },
    type() {
      if (this.type === 'pettyCash') {
        this.editedItem.advance = 0
        this.editedItem.is_petty_cash = 1
      } else if (this.type === 'advance') {
        this.editedItem.is_petty_cash = 0
      } else if (this.type === 'refund') {
        this.editedItem.advance = 0
        this.editedItem.is_petty_cash = 0
      }
      this.viewVoucherAmountCheck()
    },
  },
  created() {
    this.getLogged()
  },
  methods: {
    searching () {
      this.pagination.page = 1
      this.pagination.perPage = 5
      this.loadingItems = true
      this.refresh()
    },
    getRequestTags(status, idStatus) {
      if(this.loadingItems === true) return
      this.pagination = Object.assign({}, this.defaultPagination)
      this.searchExpense = ''
      this.expenses = []
      this.statusTag = status
      this.statusExpense = idStatus
      this.loadingItems = true
      this.searchExpense = '' //AQUÍ
      this.refresh()
    },
    checkPageChange() {
      if (this.initialPage) {
        this.initialPage = false
      } else {
        // this.valSearch = ''
        this.loadingItems = true
        this.refresh()
      }
    },
    handleRowDoubleClick(item) {
      // Aquí puedes hacer lo que quieras, como abrir un modal, navegar a otra vista, etc.
    },
    /**
     * Método para descargar archivo de excel
     */
    downloadExcelReport({ id }) {
      this.$emit('downloadExcelReport', {
        context: this,
        id,
      })
    },
    getLogged() {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    downloadRequest(item) {
      this.loadingDownload = true
      this.$emit('downloadRequest', {
        context: this,
        expensesRequest: item.travel_expenses_request.id,
        folio: item.travel_expenses_request.folio,
      })
    },
    getHistory(item) {
      this.histLoading = true
      this.histItem = item
      this.histItem.progress = []
      this.$emit('getHistory', { id: item.id, context: this })
      this.$emit('getWorkflowValidatorApprover', {
        user_id: item.user.id,
        context: this,
      })
      this.$emit('getExpensesValidators', { id: item.id, context: this })
      this.histDialog = true
    },
    getPendingValidators() {
      this.pendingValidators = this.validators
      this.histItem.progress.forEach((item) => {
        this.pendingValidators = this.pendingValidators.filter(
          (x) => x.validator.user_id !== item.user_id
        )
      })
    },
    filterHistory() {
      if (this.histItem.progress.length > 0) {
        this.histSteps.sented = this.histItem.progress.filter(
          (item) => item.status === 'Enviado'
        )
        this.histSteps.reviewed = this.histItem.progress.filter(
          (item) => item.status === 'Revisado'
        )
        this.histSteps.payable = this.histItem.progress.filter(
          (item) => item.status === 'Aprobado'
        )
        this.histSteps.paid = this.histItem.progress.filter(
          (item) => item.status === 'Pagado'
        )
        if (this.histSteps.payable.length > 0) {
          this.isApproved = true
        }
      }
    },
    filterCurrency() {
    const foundCurrencySetting = this.settings.find(x => x.setting_type.name == "st.currency" && x.company_id == this.$store.state.userLogged.company[0].id)
    this.currencySetting = foundCurrencySetting ? foundCurrencySetting : { value: { c_Moneda: 'MXN' } }
    this.tagMoneda = this.currencySetting.value.c_Moneda
    this.editedItem.currency = this.currencySetting.value
    this.defaultItem.currency = this.currencySetting.value
    },
    byCreated() {
      this.exCreated = this.expenses
      // Inserta el objeto de item regresado si encuentra similitud
      
      if (this.expensesReturned.length > 0) {
        this.exCreated.forEach(element => {
          let expenseReturnItem = null
          for (let key in this.expensesReturned) {
            if (this.expensesReturned[key].id === element.id) {
              const expensesProgress = this.expensesReturned[key].expenses_progress
              const filterItemReturn = expensesProgress.filter(itemReturn => itemReturn.status === 'Regresado')
              expenseReturnItem = filterItemReturn[0]
            }
          }
          element.expense_return = expenseReturnItem
        });
      }
    },
    checkFiscal(items) {
      var isNull = false
      items.forEach((item) => {
        if (item.subtotal === null) {
          isNull = true
        }
      })
      if (isNull) {
        return true
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        const taxID = this.userLogged.company[0].tax_id

        if (taxID === 'ING1811295P0' && item.sat_formaPago_id !== null)
          return false

        var count = 0
        if (item.gst_receipt_types_id === 1) {
          if (item.uuid !== null) {
            count += 0
          } else {
            count += 1
          }
        }
        if (count <= 0) {
          return false
        } else if (count > 0) {
          return true
        }
      }
    },
    detail(expenseId) {
      this.$router.push('/expenses/' + expenseId)
    },
    detailForm(expense) {
      this.expensesItems = expense.gst_expenses_items
      this.receipt_type = expense.gst_expenses_items[0].gst_receipt_types_id
      return this.receipt_type === 1 ? this.viewItemsF(expense.gst_expenses_items[0]) : this.viewItems(expense.gst_expenses_items[0])
    },
    viewItemsF(items) {
      const taxID = this.$store.state.userLogged.company[0].tax_id
      // if (taxID === 'ING1811295P0' && items.sat_formaPago_id !== null && items.uuid === null) {
      //   if (!items.gst_receipt_types) { items.gst_receipt_types = { name: 'fiscal' } }
      //   this.viewItemsApprobed(items)
      //   return
      // }
      this.receipt_type = items.gst_receipt_types_id
      this.dataURL = null
      this.cfdiHtml = null
      this.editedItemTip = this.defaultItemTip
      this.addTip(items)
      this.editedItemView = items
      if (items.gst_expenses_items_files.length > 0) {
        this.$emit('readXmlToHtml', {
          id: items.gst_expenses_items_files[0].files_id,
          context: this,
          type: 'viewItemsF',
        })
      }
      this.dialogForm = true
      this.loading = false
      this.disabled = false
      items.views = true
    },
    viewItems(items) {
      this.dataURL = null
      this.cfdiHtml = null
      this.editedItemTip = this.defaultItemTip
      this.receipt_type = items.gst_receipt_types_id
      this.addTip(items)
      this.editedItemView = Object.assign({}, items)
      this.editedItemView.gst_category_id = this.editedItemView.gst_categories ? this.editedItemView.gst_categories.id : null
      this.dialogForm = true
      this.loading = false
      this.disabled = false
      items.views = true
      if (items.gst_receipt_types_id === 2 || items.gst_receipt_types_id === 3) {
        if (items.gst_expenses_items_files !== undefined && items.gst_expenses_items_files !== null) {
          if (items.gst_expenses_items_files.length > 0) {
            this.$store.dispatch('getFile', { event: { context: this, fileId: items.gst_expenses_items_files[0].files_id}})
          }
        }
      }
    },
    addTip(item) {
      this.editedItemTip.id = item.id
      this.getTip(item)
    },
    getTip(item) {
      this.$emit('getTip', {
        context: this,
        id: item.id,
      })
    },
    showEditCategory(){
      this.concepts = JSON.parse(JSON.stringify(this.editedItemView.item_lines))
      this.concepts.forEach(item => { item.editCategory = false });
      this.editCategory = !this.editCategory
      this.titleTagCategory = !this.editCategory ? this.$t('general.category') : this.$t('general.expense') 
    },
    viewNext(id) {
      this.resetCategories()
      let index = this.expensesItems.findIndex((x) => x.id === id)
      if (index <= this.expensesItems.length - 2) {
        if (this.expensesItems[index + 1].gst_receipt_types_id === 1) { this.viewItemsF(this.expensesItems[index + 1]) } 
        else { this.viewItems(this.expensesItems[index + 1]) }
      } 
      else {
        if (this.expensesItems[0].gst_receipt_types_id === 1) { this.viewItemsF(this.expensesItems[0]) } 
        else { this.viewItems(this.expensesItems[0]) }
      }
    },
    viewPrevious(id) {
      this.resetCategories()
      let index = this.expensesItems.findIndex((x) => x.id === id)
      if (index !== 0) {
        if (this.expensesItems[index - 1].gst_receipt_types_id === 1) { this.viewItemsF(this.expensesItems[index - 1]) } 
        else { this.viewItems(this.expensesItems[index - 1]) }
      } else {
        if (this.expensesItems[this.expensesItems.length - 1].gst_receipt_types_id === 1) { this.viewItemsF(this.expensesItems[this.expensesItems.length - 1]) } 
        else { this.viewItems(this.expensesItems[this.expensesItems.length - 1]) }
      }
    },
    isPDF(data) {
      if (data !== null) {
        let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
        if (type === 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    openPDF() {
      var tab = window.open()
      tab.document.write(
        '<body style="margin: 0;"> <iframe src="' +
          this.dataURL +
          '" frameborder="0" style="margin: 0; padding: 0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"</iframe></body>'
      )
    },
    resetCategories(){
      this.editCategory = false
      this.editCategoryF = false
      this.editCategoryAppF = false
      this.titleTagCategory = this.$t('general.category')
      this.editItemCategories = {}
    },
    closeView(){
      this.expensesItems = []
      this.dialogForm = false
      this.editCategory = false
    },
    changeSort(header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    deleteItem(item) {
      this.editedIndex = this.expenses.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.removeDialog = true
    },
    removeItem() {
      this.loading = true
      this.delete()
    },
    closeRemove() {
      this.loading = false
      this.removeDialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },
    close() {
      this.loading = false
      this.errors = {}
      this.dialog = false
      this.histDialog = false
      this.histSteps = { sented: [], reviewed: [], payable: [], paid: [] }
      this.isPettyCash = false
      this.isDisabledPettyCash = false
      this.isDisabledOkBlue = false
      this.isDisabledRefund = false
      this.isDisabledAdvance = false
      this.isDisabledAmexCard = false
      this.type = 'refund'
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.selectMultiProject = false
      this.$refs.form.resetValidation()
      this.confirmSave = false
    },
    disabledButtons(item) {
      this.isDisabledPettyCash = true
      this.isDisabledOkBlue = true
      this.isDisabledAdvance = true
      this.isDisabledRefund = true
      this.isDisabledAmexCard = true

      if (item.is_blue_voucher === 1 && item.petty_cash_type === 0) {
        this.type = 'okBlue'
        this.isDisabledOkBlue = false
        return
      } 
      
      if (item.petty_cash_type === 1) {
        this.type = 'pettyCash'
        this.isDisabledPettyCash = false
        this.isDisabledOkBlue = item.is_blue_voucher === 0
        return
      }  
      
      if (item.petty_cash_type === 2) {
        this.type = 'amexCard'
        this.isDisabledAmexCard = false
        this.isDisabledOkBlue = item.is_blue_voucher === 0
        return
      }

      if (item.advance !== '0.00') {
        this.type = 'advance'
        this.isDisabledAdvance = false
        return
      } 
      
      if (item.advance === '0.00' && item.petty_cash_type === 0 && item.is_blue_voucher === 0) {
        this.type = 'refund'
        this.isDisabledAdvance = false
        this.isDisabledRefund = false
        return
      }
    },
    editItem(item) {
      this.disabledButtons(item)

      this.editedIndex = this.expenses.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.viatic_request_id = item.gst_travel_expenses_request_id !== null ? item.gst_travel_expenses_request_id : null
      
      if (item.gst_travel_expenses_request_id !== null) {
        this.editedItem.has_request = true
      } else {
        this.editedItem.has_request = false
      }
      
      this.selectMultiProject = item.has_multiprojects === 1
      this.dialog = true
    },
    saveValidate() {
      if(this.selectMultiProject && this.editedItem.project_list.length === 1 && this.editedItem.project_list.find(x => x === this.editedItem.project_id)) return this.showNotification(this.$t('general.selectMultiProjects'), 'error', -1)
      
      this.editedItem.has_advance = this.type
      
      if(this.editedItem.id === null || (this.editedItem.id > 0 && this.editedItem.gst_expenses_items.length === 0)) return this.save()
      
      return this.confirmSave = true
    },
    save() {
      this.editedItem.has_multiprojects = this.selectMultiProject 

      if(!this.selectMultiProject) this.editedItem.project_list = []
      
      if(this.selectMultiProject && this.editedItem.project_list.length > 0 && !this.editedItem.project_list.find(x => x === this.editedItem.project_id)) this.editedItem.project_list.unshift(this.editedItem.project_id)
      
      if(this.selectMultiProject && this.editedItem.project_list.length === 0) return this.showNotification(this.$t('general.selectMultiProjects'), 'error', -1) 

      this.errors = {}
    
      if (this.$refs.form.validate()) {
    
        if((this.type === 'pettyCash' || this.type === 'amexCard')  && this.editedItem.isVoucherAmount && (this.editedItem.voucher_amount === undefined || this.editedItem.voucher_amount === 0 || this.editedItem.voucher_amount === "" || this.editedItem.voucher_amount === "0.00")) return this.showNotification(this.$t('expenses.blueVoucher.addAmount'), 'error', -1)

        if(this.type === 'okBlue' && (this.editedItem.voucher_amount === undefined || this.editedItem.voucher_amount === 0 || this.editedItem.voucher_amount === "" || this.editedItem.voucher_amount === "0.00")) return this.showNotification(this.$t('expenses.blueVoucher.addAmount'), 'error', -1)
        
        this.loading = true
        
        if (this.editedIndex > -1) {
          this.put()
        } else {
          this.post()
        }
      }
    },
    showWorkflowDialog(item) {
      if(item.is_blue_voucher === 1 && !item.gst_expenses_items.some(x => x.file_attach.length > 0)) return this.workflowDialogValidate = true
      
      this.workflowDialog = true
      this.editedItem = Object.assign({}, item)
    },
    closeWorkflowDialog() {
      this.workflowDialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.$refs.form.resetValidation()
      this.loading = false
    },
    doStartWorkflow() {
      this.loading = true
      this.startWorkflow()
    },
    getAcuse(id) {
      this.$emit('getAcuse', {
        id,
        context: this,
      })
    },
    get() {
      this.$emit('get', { context: this})
      this.$store.dispatch('toReconcile/getUnreconciledMatches', {
        event: {
          filter_by: this.filter_by,
          company_id: this.userLogged.company[0].id,
          user_id: this.userLogged.id,
          startDate: '2021-12-01',
          endDate: new Date().toISOString().substr(0, 10),
          expense_type: 'amex',
          context: this,
        },
      })
    },
    getViatics() {
      this.$emit('getViaticsApproved', {
        context: this,
        user_id: this.userLogged.id,
        status: 'APPROVED',
      })
    },
    post() {
      this.$emit('post', {
        item: this.editedItem,
        user: this.userLogged,
        context: this,
      })
    },
    put() {
      this.$emit('put', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this,
      })
    },
    delete() {
      this.$emit('delete', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this,
      })
    },
    startWorkflow() {
      this.$emit('startWorkflow', {
        context: this,
        item: this.editedItem,
      })
    },
    refresh() {
      this.$emit('refresh', {
        context: this,
      })
    },
    showMessage() {
      if (this.totalPending > 0 && this.isRyeUser()) {
        return true
      } else {
        //Codigo temporal para usuarios abril.osorio@reactivosyequipos.com.mx, raflores@HACH.COM 
        if (this.userLogged.email === 'abril.osorio@reactivosyequipos.com.mx' || this.userLogged.email === 'raflores@HACH.COM' || this.userLogged.email === 'fernanda.vargas@reactivosyequipos.com.mx') {
          return true
        } else {
          return false
        }
        //Aqui termina codigo
        //return false
      }
    },
    isRyeUser() {
      if (this.userLogged.company[0].tax_id === 'REQ841212FE2') {
        //IF temporal para validar usuarios, mostrar boton habilitado para agregar comprobacion
        if (this.userLogged.email === 'abril.osorio@reactivosyequipos.com.mx' || this.userLogged.email === 'raflores@HACH.COM' || this.userLogged.email === 'fernanda.vargas@reactivosyequipos.com.mx') {
          return false
        } else {
          return true
        }
        //Aqui termina codigo temporal
        //return true
      } else {
        return false
      }
    },
    lockButton() {
      return false
      // Validar si el usuario es de RYE y si tiene gastos pendientes
      // if (this.totalPending > 0 && this.isRyeUser()) {
      //   return true
      // } else {
      //   return false
      // }
    },
    //REFACTORIZADO
    validationByStatus(item){
      if(item.is_blue_voucher && item.blue_voucher_validation && (item.blue_voucher_validation.status === 'CANT_SEND_OVER' || item.blue_voucher_validation.status === 'CANT_SEND_UNDER')){
        return true
      }

      if(item.is_imported_expense && item.imported_expenses_validation && (item.imported_expenses_validation.status === 'CANT_SEND_OVER' || item.imported_expenses_validation.status === 'CANT_SEND_UNDER')){
        return true
      }

      return false
    },
    viewVoucherAmountCheck(){
       this.viewVoucherAmount = (this.type === 'pettyCash' || this.type === 'amexCard') && this.editedItem.isVoucherAmount
    },
    viewExpenseReject(expenses_progress){
      return expenses_progress.some(expense => expense.status === "Regresado")
    },
    viewExpenseRejectMessage(expenses_progress){
      const expenseProgress =  expenses_progress
        .filter(expense => expense.status === "Regresado")
        .reduce((prev, current) => (prev.id > current.id) ? prev : current)

      return `${this.$t('general.commentFrom')} ${expenseProgress.user.name} "${expenseProgress.comment}"`
    }
  },
}
</script>

<style scoped>
.hist-steps {
  background-color: #63b225 !important;
}

.tdSize{
  padding: inherit !important;
}

.btnStyle {
  margin-left: -5px;
}

.btnStyle10Px {
  margin-left: -10px;
}

.size-btn {
  width: 24px; 
  height: 24px; /* Ajusta el ancho mínimo según tus preferencias */
}

.dynamic-textarea {
  max-height: 4em; /* Altura máxima deseada (3 líneas) */
  overflow-y: auto; /* Agregar barra de desplazamiento vertical cuando se exceda la altura máxima */
  /*border-bottom: 1px solid #000; */ /* Agrega linea abajo para que se vea bien el input */
}

</style>



// WEBPACK FOOTER //
// src/components/expenses.component.vue